import { Image } from "@faire/deprecated-retailer-visitor-shared/components/Image/Image";
import { bpsToPercentString } from "@faire/deprecated-retailer-visitor-shared/lib/bpsUtils";
import { Core } from "@faire/slate/foundation/color";
import { optimizeImageUrl } from "@faire/web/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps {
  className?: string;
  discountBps?: number;
  discountString?: string;
}

export const VolumePricingBadge: React.FC<IProps> = ({
  className,
  discountBps,
  discountString,
}) => {
  const isSSR = useIsSSR();
  const { strictLocalize } = useStrictLocalization();

  if (!discountBps && !discountString) {
    return null;
  }

  return (
    <Column
      justify="center"
      align="center"
      className={cn("relative w-8.5", className)}
    >
      <Image
        src={optimizeImageUrl(
          {
            url: "https://cdn.faire.com/fastly/9044ccc6e4d7ae5189fa925f465a5e1bf36e7925d494e54a1af8dd245f760878.png",
          },
          isSSR,
          { width: 34, height: 36 }
        )}
        width="100%"
        height="auto"
      />
      <Typography
        className="absolute top-2"
        variant="labelSansMedium"
        color={Core.text.primaryInverse}
      >
        {discountString ??
          bpsToPercentString(discountBps ?? 1000, strictLocalize)}
      </Typography>
    </Column>
  );
};
